import { BbsBlsSignature2020, BbsBlsSignatureProof2020 } from '@mattrglobal/jsonld-signatures-bbs';
import { DataIntegrityProof } from '@digitalbazaar/data-integrity';

const proofTypeMapping = {
  BbsBlsSignature2020,
  BbsBlsSignatureProof2020,
  DataIntegrityProof
};

export { proofTypeMapping };
